import { ErrorHandler, NgModule } from '@angular/core';
import { Routes, RouterModule, RouteReuseStrategy } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { HomeComponent } from '../components/home/home.component';
import { BlankPageComponent } from './blank-page/blank-page.component';
import { AuthGuard } from './auth.guard';
import { SiteCoordinatorComponent } from './site-management/site-coordinator/site-coordinator.component';
import { LeapFrogReportComponent } from './reports/leap-frog-report/leap-frog-report.component';
import { FacilityDemographicsComponent } from './site-management/facility-demographics/facility-demographics.component';
import { CustomRouteReuseStrategy } from './route-reuse-strategy';
import { UserManagementComponent } from './site-management/manage-users/user-management.component';
import { FacilityExportComponent } from './facility-export/facility-export.component';

const coreRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'blank',
    component: BlankPageComponent,
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'usermanagement',
    component: UserManagementComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'facilitydemographics',
    component: FacilityDemographicsComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'sitecoordinator',
    component: SiteCoordinatorComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'facilityexport',
    component: FacilityExportComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'leapfrogreport',
    component: LeapFrogReportComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'NdnqiEventRegistration',
    redirectTo: 'teleconference',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'sysdashboard',
    loadChildren: () => import('../system-dashboard/system-dashboard.module').then(m => m.SystemDashboardModule)
  },
  {
    path: 'indicators',
    loadChildren: () => import('../indicator/indicator.module').then(m => m.IndicatorModule)
  },
  {
    path: 'teleconference',
    loadChildren: () => import('../teleconference/teleconference.module').then(m => m.TeleconferenceModule)
  },
  {
    path: 'resource',
    loadChildren: () => import('../components/resource/resource.module').then(m => m.ResourceModule),
    data: { reuse: false }, // Add this line to prevent route reuse. Ensures the component is loaded each time
    canActivate: [AuthGuard]
  },
  {
    path: 'misc',
    loadChildren: () => import('../misc/misc.module').then(m => m.MiscModule)
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'unauthorized',
    component: NotAuthorizedComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(coreRoutes, {enableTracing: true, paramsInheritanceStrategy: 'always',
      errorHandler: (error: any) => {
        console.log('Router Navigation Error:', error);
      }}),
  ],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
